import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { useLanguage } from "../context/LanguageContext";

const FloatingCartButton = () => {
  const { cartItems, isCartBumping } = useCart();
  const { t } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  const totalQuantity = (cartItems || []).reduce(
    (total, item) => total + (item.quantity || 0),
    0
  );

  // Se o carrinho estiver vazio ou já estiver na tela do carrinho, não renderiza
  if (totalQuantity <= 0 || location.pathname === "/ar/cart") {
    return null;
  }

  return (
    <div
      className="fixed bottom-24 right-4 sm:bottom-24 sm:right-6 z-[60] transition-all duration-300"
      title={`${t("common.cart")}: ${totalQuantity} ${t("common.photos")}`}
    >
      <button
        type="button"
        onClick={() => navigate("/ar/cart")}
        aria-label={`${t("common.cart")} (${totalQuantity})`}
        className={`group relative flex items-center gap-2.5 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white px-4 py-3 sm:px-5 sm:py-3.5 rounded-full shadow-2xl hover:shadow-blue-500/50 transition-all duration-300 transform hover:scale-105 active:scale-95 border-2 border-white/20 backdrop-blur-md ${
          isCartBumping ? "scale-115 ring-4 ring-blue-300 animate-bounce" : ""
        }`}
      >
        <div className="relative flex items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="26px"
            viewBox="0 -960 960 960"
            width="26px"
            fill="currentColor"
            className={`transition-transform duration-300 ${
              isCartBumping ? "rotate-[-12deg] scale-110" : ""
            }`}
          >
            <path d="M289.4-98.1q-27.54 0-46.68-19.35-19.13-19.35-19.13-47t19.27-46.85q19.27-19.21 46.81-19.21 27.54 0 46.8 19.35 19.27 19.35 19.27 46.99 0 27.65-19.35 46.86T289.4-98.1Zm387.69 0q-27.54 0-46.67-19.35-19.14-19.35-19.14-47t19.27-46.85q19.27-19.21 46.81-19.21 27.54 0 46.81 19.35 19.26 19.35 19.26 46.99 0 27.65-19.34 46.86-19.35 19.21-47 19.21ZM210.36-790.41h555q24.53 0 37.09 21.09 12.57 21.09.78 42.86L678.55-500.6q-9.94 16.83-25.76 26.69-15.82 9.86-34.33 9.86H324l-52.26 96.25q-2.82 4.62-.06 10 2.76 5.39 8.53 5.39h463.22v50.25H284.67q-38.52 0-56.4-28.88-17.88-28.88-.27-61.37l61.95-112.36-149.33-314.97H65.28V-870h107.49l37.59 79.59Z" />
          </svg>

          {/* Badge flutuante com a contagem de itens */}
          <span
            className={`absolute -top-3.5 -right-3.5 bg-red-500 text-white font-extrabold text-xs px-2 py-0.5 rounded-full shadow-lg border-2 border-white transition-transform duration-300 ${
              isCartBumping ? "scale-125 bg-yellow-400 text-black" : "scale-100"
            }`}
          >
            {totalQuantity}
          </span>
        </div>

        <span className="font-bold text-sm hidden xs:inline tracking-wide">
          {t("common.cart")}
        </span>
      </button>
    </div>
  );
};

export default FloatingCartButton;
